<toast *ngFor="let toast of toasts" [toast]="toast" (onHide)="onHideToast(toast)"></toast>
